import React from 'react';
import {
  Container,
  SecondWrapper,
  BlocWrapper,
} from 'containers/AutoDetailsPage/ServicesBlock/styles';
import ServicesBloc from 'containers/AUTODashboard/Body/ServicesBloc';

const ServicesBlock = () => {
  return (
    <BlocWrapper height="288px">
      <Container padding={3}>
        <SecondWrapper container>
          <ServicesBloc isNewLine={false} mdGrid={12} smGrid={12} />
        </SecondWrapper>
      </Container>
    </BlocWrapper>
  );
};
export default ServicesBlock;
